import script from "./detail_winner_list.vue?vue&type=script&setup=true&lang=js"
export * from "./detail_winner_list.vue?vue&type=script&setup=true&lang=js"

import "./detail_winner_list.vue?vue&type=style&index=0&id=131b631e&lang=scss"

const __exports__ = script;

export default __exports__